import { CollectionStateUrlQuery } from '@/stores/filter.store';
import { ExperimentInfo } from './types';
import { experimentConfig } from './experiment-config';

function getPreferredExperimentFromUrl(
	query: CollectionStateUrlQuery,
	experiments: ExperimentInfo[]
): ExperimentInfo[] {
	if (!query || !Object.keys(query).length) return [];

	let add: ExperimentInfo | null = null;
	const setParams = query['new_preferred_variant'];
	if (setParams) {
		const [experimentName, experimentVariant] = setParams ? setParams.split(':') : [];
		if (experiments.some(exp => exp.name === experimentName)) {
			add = {
				name: experimentName as ExperimentInfo['name'],
				variant: experimentVariant,
				preferred: true,
			};
		}
	}

	let remove: ExperimentInfo | null = null;
	const disableExpName = query['new_remove_preferred_experiment'];
	if (disableExpName) {
		remove = {
			name: disableExpName as ExperimentInfo['name'],
			variant: null,
			preferred: true,
		};
	}

	return [add, remove].filter(Boolean) as ExperimentInfo[];
}

function cleanUpPreferredExperimentUrl() {
	const search = new URLSearchParams(window.location.search);
	const experimentParamsPresent = ['new_preferred_variant', 'new_remove_preferred_experiment'].some(param =>
		search.has(param)
	);
	if (!experimentParamsPresent) {
		return;
	}

	['new_preferred_variant', 'new_remove_preferred_experiment'].forEach(param => search.delete(param));
	const rewriteUrl = `${window.location.origin}${window.location.pathname}/${search.toString()}`;
	const url = rewriteUrl.endsWith('/') ? rewriteUrl.slice(0, -1) : rewriteUrl;

	history.replaceState(history.state, '', url);
}

/**
 * Retrieves the preferred experiment from the URL query parameters,
 * cleans up the URL by removing specific parameters, and returns the
 * preferred experiment information.
 *
 * @param query - The URL query params.
 * @param experiments - The list of available experiments.
 * @returns The preferred experiment information or an empty array if none found.
 */
export function getPreferredExperimentAndCleanUpUrl(query: CollectionStateUrlQuery, experiments: ExperimentInfo[]) {
	const preferredExperiment = getPreferredExperimentFromUrl(query, experiments);

	cleanUpPreferredExperimentUrl();

	return preferredExperiment;
}

export function isBackendExperiment(experimentName: string): boolean {
	return experimentName.startsWith('BE_');
}

export function isExperimentInConfig(experimentName: string): boolean {
	return experimentName in experimentConfig;
}
